import React from "react";


function EmployeesBlock({ employees }) {
    
    return (
        <div className="employees-block py">
            <div className="container-fluid">
                <div className='row'>
                    <div className='col-xl-4 col-lg-6'>
                        <span className='eyebrow'>Teymið</span>
                        <h2 className='light title'>Starfsmenn</h2>
                    </div>
                </div>
                <div className="row">
                    {employees.map((employee, index) => (
                        <div key={index} className="col-md-4 col-sm-6 employee">
                            {employee.image && (
                                <img
                                    src={employee.image}
                                    alt={employee.name}
                                    className="employee-image w-100 mb-24"
                                />
                            )}
                            <h4 className="employee-name light mb-24">{employee.name}</h4>
                            {employee.text && (
                                <div
                                    className="employee-text p-body-3"
                                    dangerouslySetInnerHTML={{ __html: employee.text }}
                                />
                            )}
                            {employee.phone && <a href={`tel:${employee.phone}`} className="employee-phone numbers mb-8">{employee.phone}</a>}
                            {employee.email && <a href={`mailto:${employee.email}`} className="employee-email numbers mb-8 d-block">{employee.email}</a>}
                            {employee.linked_in && (
                                <a
                                    href={employee.linked_in}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="employee-linked-in numbers"
                                >
                                    LinkedIn
                                </a>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default EmployeesBlock;
